import React from 'react';
import { Users } from 'lucide-react';

const EmployeeList = ({
  employees,
  employeeProfilePics,
  onSelect,
  c,
  styles,
  getAvatarColor,
  getTrilateralName,
  t,
  hasConversations,
}) => {
  if (!employees.length) return null;

  return (
    <>
      <div
        style={{
          ...styles.sectionTitle,
          marginTop: hasConversations ? '20px' : '0',
        }}
      >
        <Users size={14} />
        {t.allEmployees}
      </div>
      {employees.map((emp) => (
        <div
          key={emp.id}
          onClick={() => onSelect(emp)}
          style={styles.conversationItem}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = c.hoverBg;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={styles.avatarContainer}>
              {employeeProfilePics[emp.id] ? (
                <img
                  src={employeeProfilePics[emp.id]}
                  alt={emp.name}
                  style={{
                    ...styles.avatar,
                    objectFit: 'cover',
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    if (e.target.nextSibling?.style) e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div
                style={{
                  ...styles.avatar,
                  background: getAvatarColor(emp.name),
                  display: employeeProfilePics[emp.id] ? 'none' : 'flex',
                }}
              >
                {emp.avatar}
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontSize: '15px',
                  fontWeight: '500',
                  color: c.text,
                  marginBottom: '4px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {getTrilateralName(emp.name)}
              </div>
              <div
                style={{
                  fontSize: '13px',
                  color: c.textSecondary,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {emp.department || emp.position || emp.email}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default EmployeeList;